import { Component } from '@angular/core';

@Component({
    selector: 'check-svg',
    templateUrl: './check.component.svg',
})
export class CheckComponent { }
